import clsx from 'clsx';
import styles from 'components/UI/V3/Timeline/Item/Header/TimelineItemHeader.module.scss';
import React from 'react';

export interface TimelineItemHeaderProps {
    title: string;
    subtitle?: string;
    className?: string;
    actions?: React.ReactNode;
}

export const TimelineItemHeader: React.FC<TimelineItemHeaderProps> = ({ title, subtitle, actions, className }) => {
    return (
        <div className={clsx(styles.root, className)}>
            <div className={styles.container}>
                <p className={styles.title}>{title}</p>
                {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            </div>

            {actions && <div className={styles.actions}>{actions}</div>}
        </div>
    );
};
